import React from 'react'
import { Badge } from 'reactstrap'

// uid, groupId, addMember, removeMember, add

export default function AddMemberBadge (props) {
  let badge
  props.add
  ? badge = (
      <Badge
        color='success'
        onClick={() => props.addMember(props.uid, props.groupId)}
      >
        + Member
      </Badge>
    )
  : badge = (
    <Badge
      color='danger'
      onClick={() => props.removeMember(props.uid, props.groupId)}
    >
      - Member
    </Badge>
  )
  return <div>{badge}</div>
}


// WEBPACK FOOTER //
// ./src/components/Users/AddMemberBadge.js